import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92e70158"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "VERSIONS MOBILES APPROUVÉES")
], -1))
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = { class: "dropdown-button" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "search-container" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import {ref, reactive, onMounted} from 'vue';
import AddApprovedVersionModal from '@/components/modal/approvedVersion/AddApprovedVersionModal.vue';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from 'primevue/useconfirm';
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import InputSwitch from "primevue/inputswitch";
import Column from "primevue/column";
import {ApprovedVersionService} from "@/_services/securite/approvedVersion/ApprovedVersionService";
import {ApprovedVersion} from "@/models/securite/approvedVersion/ApprovedVersion";
import {IApprovedVersionFormSubmittedEvent} from "@/models/ApprovedVersion/IApprovedVersion";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovedVersion',
  setup(__props) {


const toast = useToast();
const isDialogVisible = ref(false);
const isLoading = ref<boolean>(true);
const confirm = useConfirm();
const tableData = ref<ApprovedVersion[]>([]);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const globalSearch = ref<string>("");
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const formResult = ref<IApprovedVersionFormSubmittedEvent | null>(null);
const filters = reactive({
    version: {
        fieldLabel: "version",
        fieldValue: "",
    },
    os: {
        fieldLabel: "os",
        fieldValue: null,
    },
    approved: {
        fieldLabel: "approved",
        fieldValue: null as number | null,
    },
    domain: {
        fieldLabel: "domain",
        fieldValue: null,
    },
});
const activeFilters = reactive<Record<string, string | number>>({});
const domainOptions = [
    { label: 'gifteo', value: 'gifteo', severity: 'danger' },
    { label: 'club-employes', value: 'club-employes', severity: 'info' },
];

onMounted(async () => {
    await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
});

const getSeverity = (value: string) => {
    const option = domainOptions.find(opt => opt.value === value);
    return option ? option.severity : null;
};

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    globalSearch?:string,
    sort?: { fieldLabel: string; fieldValue: string; },
    filters?: Record<string, string | number>,
) => {
    const [isLoadingDt, totalRecordsDt, tableDataDt] = await ApprovedVersionService.fetchApprovedVersions(itemsPerPage, page, globalSearch, sort, filters);
    isLoading.value = isLoadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    hideSpinner();
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    showSpinner();
    await populateDatatable(e.rows, e.page + 1, globalSearch.value, defaultsSort);
};

const onColumnSearch = async () => {
    Object.keys(activeFilters).forEach(key => delete activeFilters[key]);
    Object.entries(filters).forEach(([key, filter]) => {
        if (typeof filter.fieldValue === 'string' && filter.fieldValue !== '') {
            activeFilters[filter.fieldLabel] = filter.fieldValue.trim();
        }

        if (key === 'approved' && filter.fieldValue !== null) {
            activeFilters[filter.fieldLabel] = filter.fieldValue;
        }
    });

    showSpinner();
    await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort, activeFilters);
};

const onGlobalFilterKeyEnter = () => {
    if (globalSearch.value.trim() != "") {
        showSpinner();
        clearActiveFilters();
        populateDatatable(rows.value, page.value, globalSearch.value);
    }
};

const onGlobalFilterInput = () => {
    if (globalSearch.value === "") {
        showSpinner();
        clearActiveFilters();
        populateDatatable(rows.value, page.value);
    }
};

const clearActiveFilters = () => {
    const nullFilterKeys = ['approved', 'os', 'domain'];
    Object.entries(filters).forEach(([key, filter]) => {
        filter.fieldValue = nullFilterKeys.includes(key) ? null : '';
    });
    Object.keys(activeFilters).forEach(key => delete activeFilters[key]); 
}

const clearGlobalFilter = () => {
    globalSearch.value = "";
}

const onSort = (e) => {
    showSpinner();
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, globalSearch.value, sort, activeFilters);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort, activeFilters);
    }
};

const handleFormSubmit = async (result: IApprovedVersionFormSubmittedEvent) => {
    formResult.value = result;
    if (formResult.value.status == "success") {
        toast.add({ severity: 'success', summary: 'Success', detail: formResult.value.message, life: 3000 });
        clearActiveFilters();
        clearGlobalFilter();
        await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
    } else {
        toast.add({ severity: 'error', summary: 'Error', detail: formResult.value.message, life: 6000 });
    }
    isDialogVisible.value = false;
    formResult.value = null;
};

const confirmChangeStatusDialog = async (newValue: boolean, data: ApprovedVersion) => {
    const currentStatus = data.approved;
    let newStatus = currentStatus ? 'désactiver' : 'activer';
    confirm.require({
        group: 'global',
        message: `Êtes-vous sûr de vouloir ${newStatus} cette version ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'my-custom-accept-class',
        accept: async () => {
            try {
                showSpinner();
                await ApprovedVersionService.toggleApprovedStatus(data).then((response) => {
                    if (!response) {
                        throw Error
                    }
                });
                toast.add({ severity: 'success', summary: 'Success', detail: 'Le statut a bien été modifié !', life: 3000 });
                clearActiveFilters();
                await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
            }  catch (error) {
                toast.add({ severity: 'error', summary: 'Error', detail: 'Une erreur est survenue.', life: 3000 });
                hideSpinner();
            }
        },
    });
};

const confirmDeleteDialog = (data: ApprovedVersion) => {
    confirm.require({
        group: 'global',
        message: `Êtes-vous sûr de vouloir supprimer cette version ?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'my-custom-accept-class',
        accept: async () => {
            try {
                showSpinner();
                clearActiveFilters();
                await ApprovedVersionService.deleteApprovedVersion(data).then((response) => {
                    if (!response) {
                        throw Error
                    }
                });
                toast.add({ severity: 'success', summary: 'Supprimé', detail: 'Version supprimée avec succès', life: 3000 });
                await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la suppression', life: 3000 });
                hideSpinner();
            }
        }
    });
};

const formatDate = (dateString: string) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

const showSpinner = () => {
    isLoading.value = true;
};

const hideSpinner = () => {
    isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Toast),
    _createVNode(_unref(ConfirmDialog), {
      group: "global",
      closeOnEscape: false,
      closable: false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          label: "Ajouter",
          icon: "pi pi-plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isDialogVisible.value=true)),
          class: "custom-button"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        removableSort: "",
        paginator: "",
        filterDisplay: "row",
        tableStyle: "min-width: 50rem",
        showGridlines: "",
        stripedRows: "",
        columnResizeMode: "fit",
        value: tableData.value,
        rowHover: true,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        onPage: onPaginate,
        onSort: _cache[11] || (_cache[11] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: globalSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((globalSearch).value = $event)),
                placeholder: "Rechercher par version, platforme",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onGlobalFilterKeyEnter()), ["enter"])),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (onGlobalFilterInput()))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "version",
            header: "Version",
            showFilterMenu: false,
            sortable: ""
          }, {
            filter: _withCtx(() => [
              _createVNode(_unref(InputText), {
                modelValue: filters.version.fieldValue,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.version.fieldValue) = $event)),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (onColumnSearch()), ["enter"])),
                placeholder: "Rechercher",
                class: "p-column-filter",
                style: {"min-width":"12rem"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "os",
            header: "Platforme",
            showFilterMenu: false,
            sortable: ""
          }, {
            filter: _withCtx(() => [
              _createVNode(_unref(Dropdown), {
                modelValue: filters.os.fieldValue,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.os.fieldValue) = $event)),
                options: [
                            { label: 'iOS', value: 'iOS', icon: 'pi pi-apple', severity: 'info' },
                            { label: 'ANDROID', value: 'ANDROID', icon: 'pi pi-android', severity: 'success' }
                        ],
                onChange: _cache[7] || (_cache[7] = ($event: any) => (onColumnSearch())),
                optionLabel: "label",
                optionValue: "value",
                placeholder: "Selectionnez",
                class: "p-column-filter",
                style: {"min-width":"12rem"},
                showClear: true
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode(_component_Tag, {
                    value: slotProps.option.label,
                    severity: slotProps.option.severity,
                    icon: slotProps.option.icon
                  }, null, 8, ["value", "severity", "icon"])
                ]),
                value: _withCtx((slotProps) => [
                  (slotProps.value !== null)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        value: slotProps.value === 'iOS' ? 'iOS' : 'ANDROID',
                        severity: slotProps.value === 'iOS' ? 'info' : 'success',
                        icon: slotProps.value === 'iOS' ? 'pi pi-apple' : 'pi pi-android'
                      }, null, 8, ["value", "severity", "icon"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Selectionnez ")
                      ], 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                value: slotProps.data.os,
                severity: slotProps.data.os === 'iOS' ? 'info' : 'success',
                icon: slotProps.data.os === 'iOS' ? 'pi pi-apple' : 'pi pi-android'
              }, null, 8, ["value", "severity", "icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "domain",
            header: "Domaine",
            showFilterMenu: false,
            sortable: ""
          }, {
            filter: _withCtx(() => [
              _createVNode(_unref(Dropdown), {
                modelValue: filters.domain.fieldValue,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.domain.fieldValue) = $event)),
                options: domainOptions,
                onChange: _cache[9] || (_cache[9] = ($event: any) => (onColumnSearch())),
                optionLabel: "label",
                optionValue: "value",
                placeholder: "Selectionnez",
                class: "p-column-filter",
                style: {"min-width":"12rem"},
                showClear: true
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode(_component_Tag, {
                    value: slotProps.option.label,
                    severity: slotProps.option.severity
                  }, null, 8, ["value", "severity"])
                ]),
                value: _withCtx((slotProps) => [
                  (slotProps.value !== null)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        value: slotProps.value,
                        severity: getSeverity(slotProps.value)
                      }, null, 8, ["value", "severity"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Selectionnez")
                      ], 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                value: slotProps.data.domain,
                severity: getSeverity(slotProps.data.domain),
                "data-domain": slotProps.data.domain
              }, null, 8, ["value", "severity", "data-domain"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "createdAt",
            header: "Date d'ajout",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(formatDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Ajouté par" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.createdBy ? `${slotProps.data.createdBy.firstname} ${slotProps.data.createdBy.lastname}` : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "approved",
            header: "Statut",
            showFilterMenu: false,
            sortable: ""
          }, {
            filter: _withCtx(() => [
              _createVNode(_unref(Dropdown), {
                modelValue: filters.approved.fieldValue,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.approved.fieldValue) = $event)),
                options: [
                            { label: 'Actif', value: 1, severity: 'success' },
                            { label: 'Inactif', value: 0, severity: 'danger' }
                        ],
                onChange: onColumnSearch,
                optionLabel: "label",
                optionValue: "value",
                placeholder: "Selectionnez",
                class: "p-column-filter",
                style: {"min-width":"12rem"},
                showClear: true
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode(_component_Tag, {
                    value: slotProps.option.label,
                    severity: slotProps.option.severity
                  }, null, 8, ["value", "severity"])
                ]),
                value: _withCtx((slotProps) => [
                  (slotProps.value !== null)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        value: slotProps.value === 1 ? 'Actif' : 'Inactif',
                        severity: slotProps.value === 1 ? 'success' : 'danger'
                      }, null, 8, ["value", "severity"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Selectionnez ")
                      ], 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                value: slotProps.data.approved ? 'Actif' : 'Inactif',
                severity: slotProps.data.approved ? 'success' : 'danger',
                rounded: ""
              }, null, 8, ["value", "severity"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), null, {
            header: _withCtx(() => [
              _hoisted_8
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputSwitch), {
                "model-value": slotProps.data.approved,
                "onUpdate:modelValue": (value) => confirmChangeStatusDialog(value, slotProps.data)
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_unref(Button), {
                onClick: () => confirmDeleteDialog(slotProps.data),
                type: "button",
                title: "Supprimer",
                icon: "pi pi-trash",
                class: "ml-1 p-button-danger"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ]),
    _createVNode(AddApprovedVersionModal, {
      visible: isDialogVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((isDialogVisible).value = $event)),
      "onUpdate:formSubmitted": _cache[13] || (_cache[13] = ($event: any) => (handleFormSubmit($event)))
    }, null, 8, ["visible"])
  ], 64))
}
}

})